import { css } from "styled-components";

export const TagBadgeStyle = css`
  padding: 4px 12px;
  font-size: 12px;
  border-radius: 4px;
  display: inline-block;
  font-weight: 700;
  text-align: center;

  &.tag-sunday,
  &.sunday {
    background: #eef4ff;
    color: #004094;
  }

  &.tag-friday,
  &.friday {
    background: #fff0f0;
    color: #c0392b;
  }

  &.tag-special,
  &.special {
    background: #f0fdf4;
    color: #27ae60;
  }

  &.tag-seasonal,
  &.seasonal {
    background: #eef4ff;
    color: #004094;
  }
`;
